import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';
import { UserView } from './UserView';
import { TaskDefinition } from 'gossamer-model';

export interface WorkflowViewRow {
  root_id: number;
  institution_id: number;
  assigned_to: string;
  pending_count: number;
  active_count: number;
  completed_count: number;
  completed_percentage: string;
}

export const WorkflowView: Entity<WorkflowViewRow> = {
  id: 'WorkflowView',
  title: 'Workflow',
  service: 'main',
  rowLabel: (row: WorkflowViewRow) => row.assigned_to,
  primaryKeyFields: ['root_id', 'institution_id', 'assigned_to'],
  source: {
    tableName: 'public.workflow_view',
  },
  defaultSort: [['assigned_to', 'ASC']],
  security: [
    { role: 'admin', action: 'read', access: 'conditional', condition: 'institution_id = {adminInstitutionId}' },
    { role: 'staff', action: 'read', access: 'all' },
  ],
  fields: {
    root_id: {
      seq: 5,
      type: FieldType.Reference,
      label: 'Workflow',
      refEntity: TaskDefinition,
      listColumn: true,
    },
    institution_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
    },
    assigned_to: {
      seq: 15,
      type: FieldType.Reference,
      label: 'User',
      listColumn: true,
      refEntity: UserView,
    },
    pending_count: {
      seq: 20,
      type: FieldType.Integer,
      label: 'Pending Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    active_count: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Active Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    completed_count: {
      seq: 30,
      type: FieldType.Integer,
      label: 'Completed Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    completed_percentage: {
      seq: 35,
      type: FieldType.Text,
      label: 'Completed Percentage',
      listColumn: true,
      fieldGroup: 'summary',
      listColumnAlign: 'right',
      persistence: PersistenceType.FrontEndOnly,
      evaluateFrontEndIn: (row: WorkflowViewRow) => {
        const denominator = row.pending_count + row.active_count + row.completed_count;
        return denominator === 0 ? '-' : ((row.completed_count / denominator) * 100).toFixed(0) + '%';
      },
    },
  },
};
